import { render, staticRenderFns } from "./LightTip.vue?vue&type=template&id=fecafe96&scoped=true&"
import script from "./LightTip.vue?vue&type=script&lang=js&"
export * from "./LightTip.vue?vue&type=script&lang=js&"
import style0 from "./LightTip.vue?vue&type=style&index=0&id=fecafe96&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fecafe96",
  null
  
)

component.options.__file = "LightTip.vue"
export default component.exports